import React from 'react';
import { classNames } from '../helpers/functions';

export default ({
	status = 'info',
	size = 'sm',
	className,
	children,
	onClick,
}) => {
	const BG_MAPPING = {
		success: 'bg-green-50',
		info: 'bg-blue-50',
		caution: 'bg-yellow-100/80',
		warning: 'bg-orange-100/80',
		error: 'bg-red-50',
		default: 'bg-gray-50',
	}[status];

	const BUTTON_BG_MAPPING = {
		success: 'bg-green-200',
		info: 'bg-blue-100 hover:bg-blue-200',
		caution: 'bg-yellow-100/80',
		warning: 'bg-orange-100/80',
		error: 'bg-red-50',
		default: 'bg-gray-50',
	}[status];

	const TEXT_COLOR_MAPPING = {
		success: 'text-green-700',
		info: 'text-blue-800/80',
		caution: 'text-yellow-800',
		warning: 'text-orange-800',
		error: 'text-red-700',
		default: 'text-gray-600',
	}[status];

	const SIZE_MAPPING = {
		xxs: 'text-xxs',
		xs: 'text-xs',
		sm: 'text-sm',
	}[size];

	return (
		<div
			className={classNames(
				BG_MAPPING,
				'p-4',
				onClick && 'cursor-pointer',
				className
			)}
			onClick={() => (typeof onClick === 'function' ? onClick() : {})}
		>
			<div className="flex items-center">
				<div className="flex-1 px-2">
					<p className={classNames(SIZE_MAPPING, TEXT_COLOR_MAPPING)}>
						{children}
					</p>
				</div>
			</div>
		</div>
	);
};
